import VueRouter from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from '../store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { syncClarityWithRoute } from '../helper/ClarityHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';
import { listenOnboardingUpdates } from 'dashboard/helper/onboardingSync';
import { onboardingGuard } from '../helper/onboardingRouteGuard';

const routes = [...dashboard.routes];

listenOnboardingUpdates(store);

export const router = new VueRouter({ mode: 'history', routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next, { getters }) => {
  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    window.location = '/app/login';
    return '/app/login';
  }

  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, getters.getCurrentUser, getters);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async (to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });
    syncClarityWithRoute(to.name);

    await userAuthentication;

    // validateAuthenticateRoutePermission calls `next` itself for every
    // outcome except the not-logged-in case (a hard `window.location`
    // reload that never calls it at all). Intercept the "everything
    // passed, proceed" case specifically to layer the onboarding check in
    // before the real `next()` fires — see onboardingRouteGuard.js for why
    // this needs to be global rather than a beforeEnter like
    // subscriptionGuard (it has to catch a plain refresh too, not just
    // fresh navigations into ~20 opted-in routes).
    validateAuthenticateRoutePermission(
      to,
      async permissionRedirect => {
        if (permissionRedirect !== undefined) {
          next(permissionRedirect);
          return;
        }
        await onboardingGuard(to, from, next, store);
      },
      store
    );
  });
};

export default router;
